import PatientEncounterDashboard from "./PatientEncounterDashboard";
export default PatientEncounterDashboard;
